import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssetManagement, AssetVerify, AssetView } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../asset-management-api-endpoints";


@Injectable({
  providedIn: "root",
})
export class AssetManagementDashboardService {
  private readonly assetmanagementreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getAmDashboardData(): Observable<AssetManagement> {
    return this.http
      .post<AssetManagement>(
        `${this.assetmanagementreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCH}`,
        { }
      )
      .pipe(
        map((response) => response),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

}
